import React from 'react'
import SimpleBanner from '../../components/User/Common/SimpleBanner'
import NoticePage from '../../components/User/Common/Noticepage'

const Career = () => {
  return (
    <div>
      <SimpleBanner title='Notice' subheading='Home > Notice'/>
      <NoticePage/>
    </div>
  )
}

export default Career